<template lang="pug">
  app-modal(
    :titulo="titulo",
    :width="width"
    @closeModal="$emit('closeModal')"
  )
    template(slot="body")
      div(v-if="dadosVtn")
        VisualizarVtnRR(
          v-if="dadosVtn",
          :vtn="dadosVtn",
          :processo="processo",
          :isUsuarioExterno="false",
          :isVisualizar="true"
        )
</template>

<script>
import AppModal from '@/components/AppModal'
import { mapActions } from 'vuex'
import VisualizarVtnRR from '@/screens/analise/vtn/VisualizarVtnRR.vue'

export default {
  components: {
    AppModal,
    VisualizarVtnRR
  },

  data () {
    return {
      dadosVtn: null,
      processo: null
    }
  },

  props: {
    width: {
      type: Number,
      default: window.innerWidth * 0.85
    },
    tipo: {
      type: String,
      default: null
    },
    titulo: {
      type: String,
      required: true
    },
    conteudo: {
      type: Number,
      required: true
    },
    isProcesso: {
      type: Boolean,
      default: false
    },
    isVTN: {
      type: Boolean,
      default: false
    }
  },

  async mounted () {
    this.processo = await this.getProcessoById(this.conteudo)
    await this.getVtnRR()
  },

  methods: {
    ...mapActions({
      getVtnByIdProcesso: 'vtn/getVtnbyIdProcesso',
      getProcessoById: 'processo/getProcessoById'
    }),
    async getVtnRR () {
      this.dadosVtn = await this.getVtnByIdProcesso(this.conteudo)
      if (this.dadosVtn) {
        this.$store.commit('vtn/SET_VTN', this.dadosVtn)
        this.idVtn = this.dadosVtn.id
      }
    },
    changePdfDownload (documento) {
      this.bytes = documento.bytes
      this.despachoAtual = this.despachos.find(
        despacho => despacho.id === documento.id
      )
    }
  }
}
</script>

<style scoped lang="scss">
p.message {
  width: 80%;
  margin: 0 auto;
}

.flex {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppModalVisualizarVTNRR.vue